<template>
  <div class="disease-pest">
    <van-nav-bar
      :border="false"
      title="选择作物"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="list-container">
      <van-sidebar v-model="activeKey">
        <van-sidebar-item
          v-for="i in typeList"
          :key="i.name"
          :title="i.name"
          @click="activeType = i.name"
        />
      </van-sidebar>
      <div class="item-list">
        <div class="list-grid">
          <router-link
            v-for="i in list"
            :key="i.agri_type_id"
            :to="{name:'DiseasePestCrop',query:{id:i.agri_type_id,name:i.name}}"
            class="item"
          >
            <van-image
              :src="i.pic"
              width="70"
              height="70"
              fit="cover"
              round
              lazy-load
            />
            <div class="name">
              {{ i.name }}
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'DiseasePest',
  data() {
    return {
      activeKey: 0,
      activeType: '热门作物',
      typeList: []
    }
  },
  computed: {
    list() {
      const data = this.typeList.find(i => {
        return i.name === this.activeType
      })
      return data ? data.items : []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      api.controlAgriDiseasesFindList().then(res => {
        this.typeList = [{ name: '热门作物', items: res.hot_list }, ...res.data]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.disease-pest {
  position: relative;
  height: 100%;
  .list-container {
    height: calc(100vh - 46px);
    display: flex;
  }
}
.van-sidebar {
  height: 100%;
  flex-shrink: 0;
  background: #EAF2F9;
  .van-sidebar-item {
    background-color: transparent;
    &::before {
      background-color: @primary-color;
    }
  }
}
.item-list {
  height: 100%;
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px 10px;
  background: #F3F7F8;
  .list-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 80px);
    justify-content: space-between;
    justify-items: center;
    grid-gap: 20px 10px;
  }
  .item {
    .van-image {
      box-shadow: 0 0 10px 1px rgba(163,163,163,.4);
    }
    .name {
      text-align: center;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
